import { createQueryParams } from '@nexio/emvio-util-app';
import config from '../../config/config';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const PROCESSOR_ONBOARDING_LOAD = 'PROCESSOR_ONBOARDING/PROCESSOR_ONBOARDING_LOAD';
export const PROCESSOR_ONBOARDING_SUCCESS = 'PROCESSOR_ONBOARDING/PROCESSOR_ONBOARDING_SUCCESS';
export const PROCESSOR_ONBOARDING_FAILURE = 'PROCESSOR_ONBOARDING/PROCESSOR_ONBOARDING_FAILURE';

export const fetchUrl = `${config.processorOnboardingApiUrl}/applications`;

export function getProcessorOnboarding(filters, page, pageSize, sorters) {
    const queryParamsString = createQueryParams({
        filters,
        page,
        pageSize,
        sorters
    });

    return {
        failureActionTypeOrCreator: getProcessorOnboardingFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: PROCESSOR_ONBOARDING_LOAD,
        successActionTypeOrCreator: getProcessorOnboardingSuccessActionCreator
    };
}

export function getProcessorOnboardingSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, PROCESSOR_ONBOARDING_SUCCESS, 'processorOnboarding');
}

export function getProcessorOnboardingFailureActionCreator(error) {
    return {
        error,
        type: PROCESSOR_ONBOARDING_FAILURE
    };
}

